import { useToastContext } from "components/alert/ToastContext";
import Pageable from "model/page/Pageable";
import ItemPedido from "model/producao/ItemPedido";
import LigarOpPedido from "model/producao/LigarOpPedido";
import OrdemProducao from "model/producao/OrdemProducao";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableStateEvent } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import GerarOpService from "service/producao/GerarOpService";
import OrdemProducaoService from "service/producao/OrdemProducaoService";
import PedidoService from "service/producao/PedidoService";

interface ModalLigarOPsItemPedidoProps {
    visible: boolean;
    onHide: () => void;
}

const gerarOpService = new GerarOpService();
const ordemProducaoService = new OrdemProducaoService();
const pedidoService = new PedidoService();

export default function ModalLigarOPsItemPedido(props: ModalLigarOPsItemPedidoProps) {

    const { msgAlerta, msgSucesso, msgErro } = useToastContext();

    const [idTela, setIdTela] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [itensPedido, setItensPedido] = useState<ItemPedido[]>([]);
    const [itemPedidoSelecionado, setItemPedidoSelecionado] = useState<ItemPedido>();
    const [ordensProducao, setOrdensProducao] = useState<OrdemProducao[]>([]);
    const [ordensProducaoSelecionadas, setOrdensProducaoSelecionadas] = useState<OrdemProducao[]>([]);
    const [pageableItensPedido, setPageableItensPedido] = useState(new Pageable(0, 10, "pedido.numeroPedido,DESC", 0));
    const [pageableOrdensProducao, setPageableOrdensProducao] = useState(new Pageable(0, 2, "numero,DESC", 0));
    const [totalElementsItensPedido, setTotalElementsItensPedido] = useState<number>(0);
    const [totalElementsOrdensProducao, setTotalElementsOrdensProducao] = useState<number>(0);

    useEffect(() => {
        setLoading(true);
    }, []);

    useEffect(() => {
        if (loading) {
            gerarOpService.pesquisarOpsSemPedido(pageableOrdensProducao).then((ops) => {
                setOrdensProducao(ops.content);
                setTotalElementsOrdensProducao(ops.totalElements);
            }).catch((error) => {
                console.error(error);
            })

            gerarOpService.pesquisarItensAbertos(pageableItensPedido).then((itens) => {
                setItensPedido(itens.content);
                setTotalElementsItensPedido(itens.totalElements);
            }).catch((error) => {
                console.error(error);
            })

            setLoading(false);
        }
    }, [loading, pageableItensPedido, pageableOrdensProducao]);

    const onPageItensPedido = (event: DataTableStateEvent) => {
        setPageableItensPedido({ ...pageableItensPedido, page: event.page !== undefined ? event.page : 0, first: event.first });
        setLoading(true);
    };

    const onPageOrdensProducao = (event: DataTableStateEvent) => {
        setPageableOrdensProducao({ ...pageableOrdensProducao, page: event.page !== undefined ? event.page : 0, first: event.first });
        setLoading(true);
    };

    const footer = <div>
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onHide} />
        {idTela == 1 && <Button label="Próximo" icon="pi pi-arrow-right" className="p-button-text"
            onClick={() => { setIdTela(2) }} disabled={ordensProducaoSelecionadas.length <= 0 ? true : false} />}
        {idTela == 2 && <Button label="Anterior" icon="pi pi-arrow-left" className="p-button-text"
            onClick={() => {
                setIdTela(1);
                setItemPedidoSelecionado(undefined);
            }} />}
        {idTela == 2 && <Button label="Confirmar" icon="pi pi-check" className="p-button-text"
            disabled={itemPedidoSelecionado == null ? true : false}
            onClick={() => ligarOpPedido() } />}
    </div>

    const ligarOpPedido = () => {
        let item = new LigarOpPedido();
        item.idsOps = ordensProducaoSelecionadas.map((op) => op.id);
        item.idItemPedido = itemPedidoSelecionado?.id || 0;

        setLoading(true);

        gerarOpService.ligarOpPedido(item).then(() => {
            msgSucesso("Ligar OP pedido", "OP(s) ligadas com sucesso");
            setLoading(false);
            props.onHide();
        }).catch((err) => {
            console.log(err)
            setLoading(false);
            if (err && err.data && err.data.message) {
                msgAlerta("Atenção", err.data.message);
            } else {
                msgErro("Erro", "Erro ao ligar OP(s)");
            }
        });
    }

    return (
        <>
            <Dialog visible={props.visible} style={{ width: '65vw', minHeight: "50vh" }} modal onHide={props.onHide}
                header="Ligar OPs não associadas a itens de pedido" footer={footer}>

                {idTela == 1 && <DataTable emptyMessage="Nenhum registro encontrado"
                    value={ordensProducao} paginator lazy rows={2} header="Ordens de produção"
                    first={pageableOrdensProducao.first} totalRecords={totalElementsOrdensProducao} onPage={onPageOrdensProducao}
                    loading={loading}
                    dataKey="id"
                    selectionMode="multiple"
                    dragSelection
                    metaKeySelection={false}
                    selection={ordensProducaoSelecionadas}
                    onSelectionChange={(e) => setOrdensProducaoSelecionadas(e.value as OrdemProducao[])}
                >

                    <Column field="numero" header="Número" />
                    <Column field="produto.nome" header="Produto" />
                    <Column field="qtPrevista" header="Quantidade" />
                    <Column field="status" header="Status" body={(rowData) => ordemProducaoService.getStatus(rowData.status)} />

                </DataTable>}

                {idTela == 2 && <DataTable emptyMessage="Nenhum registro encontrado"
                    value={itensPedido} paginator lazy rows={10} header="Itens de pedido"
                    first={pageableItensPedido.first} totalRecords={totalElementsItensPedido} onPage={onPageItensPedido}
                    loading={loading}
                    dataKey="id"
                    selectionMode="single"
                    selection={itemPedidoSelecionado}
                    onSelectionChange={(e) => setItemPedidoSelecionado(e.value as ItemPedido)} >

                    <Column field="pedido.numeroPedido" header="Pedido" />
                    <Column field="sequencial" header="Sequência" />
                    <Column field="produto.codigo" header="Cód. Produto" />
                    <Column field="produto.nome" header="Nome Produto" />
                    <Column field="pedido.cliente.nome" header="Cliente" />
                    <Column field="status" header="Status" body={(rowData) => pedidoService.getStatusItem(rowData.status)} />

                </DataTable>}

            </Dialog>
        </>
    )
}